var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4172_34623)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60 120C93.1368 120 120 93.1374 120 60C120 26.8629 93.1368 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1374 26.8629 120 60 120Z",
    fill: "#B9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M60.6 22.7998C47.0208 22.7998 36 33.5662 36 46.8317C36 59.8411 46.4304 70.4153 60.272 70.7998H60.8624H61.3216H61.4528C74.704 70.3512 85.1344 59.8411 85.2 46.8317C85.2 33.5662 74.1792 22.7998 60.6 22.7998Z",
    fill: "#144DD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M104.4 103.093C92.9009 113.556 77.5256 120 60.6 120C43.6743 120 28.2991 113.556 16.8 103.093C18.3504 97.2875 22.5495 91.9921 28.6867 87.9089C46.323 76.2973 75.0062 76.2973 92.5133 87.9089C98.715 91.9921 102.85 97.2875 104.4 103.093Z",
    fill: "#144DD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4172_34623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.9d8308ef216533f4959da214b9f6c61e.svg";
export { ForwardRef as ReactComponent };